<template>
  <div class="record-package">
    <div class="header" v-if="!isapplets">
      <van-icon name="arrow-left" size="20" color="#333" @click="goBack" />
      <span class="title">学习记录</span>
      <span class="exp"></span>
    </div>
    <div class="record_content" @scroll='loadmore($event)'>
      <div class="record_box">
        <div class="nodata" v-if="datalist&&datalist.length==0">
         <p><img src="../../../static/images/record.png" alt=""></p>
          <p>暂无学习记录,请先去学习课程</p>
        </div>
        <div class="record_detail" v-for='i in datalist'>
          <p class="record_date" v-if="i.day">{{i.day}}</p>
          <div class="record_descript" v-for='item in i.list' @click='godetail(item)'>
            <p class="record_time">{{item.action_time}}</p>
            <p class="record_pathname">{{item.path_name}}</p>
            <div class="record_info">
              <img v-if='item.unit_type == 1 || item.unit_type == 7' src="static/images/doc.png" alt="">
              <img v-if='item.unit_type == 2' src="static/images/video.png" alt="">
              <img v-if='item.unit_type == 4 || item.unit_type == 5' src="static/images/write.png" alt="">
              <img v-if='item.unit_type == 6' src="static/images/zhibo.png" alt="">
              <img v-if='item.unit_type == 66' src="static/images/playback.png" alt="">
              <div class="record_type">
                <p class="record_name">{{item.unit_name}} <span></span></p>
                <p class="record_icon" v-if='item.unit_type == 1 || item.unit_type == 7'>文档</p>
                <p class="record_icon" v-if='item.unit_type == 2'>视频 | {{item.total_length | formatSeconds}} 已学习{{item.percentage}}</p>
                <p class="record_icon" v-if='item.unit_type == 4 || item.unit_type == 5'>练习</p>
                <p class="record_icon" v-if='item.unit_type == 6'>直播  | {{item.livingBeginTime | timeFormat}} - {{item.livingEndTime | localDateH}}</p>
                <p class="record_icon" v-if='item.unit_type == 66'>回放  | {{item.livingBeginTime | timeFormat}} - {{item.livingEndTime | localDateH}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="no_more" v-if='record_tip'>没有更多记录了</p>
    </div>
    <div class="class_dialog" v-if='zujian_flag'>
      <div class="dialog_box">
        <div class="dialog_message">手机浏览器暂不支持查看该课件<br/>你可在"{{appname}}"进行查看</div>
        <p><span @click='cancel_flag'>取消</span>
          <!-- <wx-open-launch-app v-if='ua.match(/MicroMessenger/i) == "micromessenger"&&android'
            id="launch-btn" @error="handleErrorFn" @launch="handleLaunchFn" :appid=appid
          >
            <script type="text/wxtag-template">
              <style>.btn { color: #fff; font-size: 10px; text-align:center; line-height:23px}
			         </style>
               <div class="btn">去APP查看</div>
            </script>
          </wx-open-launch-app> -->
          <span v-if='android' class="goapp"><a :href=scheme @click='search_flag'>打开APP</a></span>
          <span v-else-if='ios' class="goapp" @click='search_flag'>去APP查看</span>
        </p>
      </div>
    </div>
    <arouse v-if="arshow" @arouse='receive'></arouse>
  </div>
</template>
<script>
import timeFormat from "../../utils/timeFormat.js";
import formatSeconds from "../../utils/formatSecond.js";
import localDateH from "../../utils/localDate.js";
import arouse from '../arouse/index.vue'
import { Toast } from "vant";

export default {
  data() {
    return {
      ticket: JSON.parse(localStorage.getItem("ticketObj"))["offcn-ticket"],
      ticket_source: JSON.parse(localStorage.getItem("ticketObj")).ticket_source,
      datalist: [],
      page: 1,
      record_tip: false,
      catainfo: null,
      zujian_flag: false,
      ua: navigator.userAgent.toLowerCase(),
      android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
      ios: navigator.userAgent.match(/iPad/) || navigator.userAgent.match(/iPhone/) || navigator.userAgent.match(/iPod/),
      isapplets: false,
      sf: '',
      appid: '',
      scheme: '',
      arshow: false,
      isweixin: false
    }
  },
  components: {
    arouse
  },
  filters: {
    formatSeconds: function (value) {
      return formatSeconds(value);
    },
    timeFormat: function (value) {
      return timeFormat(value);
    },
    localDateH: function (value) {
      return localDateH(value);
    }
  },
  methods: {
    receive (val) {
      this.arshow = val
    },
    handleErrorFn(e) {
      this.arshow = true
      console.log(JSON.stringify(e), '跳转失败')
      Toast("当前手机未下载中公教育app");
      this.download() // 这里跳转App下载页面
    },
    // 监听launch 函数
    handleLaunchFn(e) {
      // 跳转成功
      console.log(JSON.stringify(e), '跳转成功')
    },
    download(){
      //判断iPhone|iPad|iPod|iOS
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          window.location.href ="https://apps.apple.com/cn/app/%E4%B8%AD%E5%85%AC%E6%95%99%E8%82%B2/id735754930";
      } else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
          window.location.href ="https://a.app.qq.com/o/simple.jsp?pkgname=com.offcn.android.offcn&channel=0002160650432d595942&fromcase=60001";
      } else {  // PC端
          window.location.href ="https://www.offcn.com/daohang/zgapp/#nub1";
      }
    },
    handleJudgeWechat() {
      const wechatInfo = window.navigator.userAgent.match(
        /MicroMessenger\/([\d\.]+)/i
      );
      if (!wechatInfo) return;
      let judgewechat = wechatInfo[1].split(".");
      let flag = false;
      if (judgewechat[0] >= 7) {
        if (judgewechat[1] >= 0) {
          if (judgewechat[2] >= 12) {
            this.wechatState = true;
            flag = true;
          }
        }
      }
      if (!flag) {
        Toast.fail('请升级当前微信版本');
        return false
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    getRecord (page) {
      this.$api.LEARNGET({
        page: page,
        page_size: 10,
        "offcn-ticket": this.ticket || 'ssoticket',
        ticket_source: this.ticket_source,
      }).then((res) => {
        if (res.code == 0) {
          let newStr = ''
          if (res.data.list != '') {
            newStr = res.data.list[0].day
          }
          if (this.datalist.length > 0) {
            if (this.datalist[this.datalist.length-1].day == newStr) {
              res.data.list[0].day = ''
            }
          }
          this.datalist = this.datalist.concat(res.data.list)
          let all_length = 0
          for (let i in res.data.list) {
            all_length += res.data.list[i].list.length
          }
          if (all_length && all_length < 10) {
            this.record_tip = true
          }
        } else if (res.code == 2) {
          this.$router.push({ path: "/" });
        }
      })
    },
    loadmore (e) {
      if(e.srcElement.scrollHeight - e.srcElement.scrollTop == e.srcElement.offsetHeight) {
        if (!this.record_tip) {
          this.page++
          this.getRecord(this.page)
        }
      }
    },
    godetail (item) {
      if (item.unit_type == 1) {
        this.$api.GETCATALOG({
          system_order_num: item.system_order,
          package_id: item.package_id,
          coding: item.coding,
          menu_id: item.unit_id
        }).then((res) => {
          if (res.code == 0) {
            this.$router.push({
              path: "/file",
              query: {
                order_id: item.system_order,
                package_id: item.package_id,
                cid: item.coding,
                unit_id: item.unit_id,
                module_type: 1,
                url: res.data.catalog.info.url
              }
            })
          } else if (res.code == 2) {
            this.$router.push({ path: "/" });
          }
        })
      } else if (item.unit_type == 2) {
        this.$api.GETCATALOG({
          system_order_num: item.system_order,
          package_id: item.package_id,
          coding: item.coding,
          menu_id: item.unit_id
        }).then((res) => {
          if (res.code == 0) {
            this.$router.push({
              path: "/video",
              query: {
                order_id: item.system_order,
                package_id: item.package_id,
                cid: item.coding,
                media_id: res.data.catalog.info.video_id,
                name: item.unit_name,
                time: item.total_length,
                id: item.unit_id,
                video_source: item.video_source,
              }
            })
          } else if (res.code == 2) {
            this.$router.push({ path: "/" });
          }
        })
      } else if (item.unit_type == 4 || item.unit_type == 5) {
        Toast("请在《中公教育》APP或学习中心，查看练习");
      } else if (item.unit_type == 6) {
        let time = parseInt(new Date().getTime() / 1000)
        this.$api.GETCATALOG({
          system_order_num: item.system_order,
          package_id: item.package_id,
          coding: item.coding,
          menu_id: item.unit_id
        }).then((res) => {
          if (res.code == 0) {
            let info = res.data.catalog.info
            if (time > res.data.catalog.info.end_time && res.data.catalog.info.is_playback == 0) {
              Toast("直播已结束");
            } else if (time < res.data.catalog.info.start_time) {
              Toast("直播未开始");
            } else if (item.live_type == 1) {
              this.$router.push({
                path: "/livevod",
                query: {
                  order_id: item.system_order,
                  package_id: item.package_id,
                  cid: item.coding,
                  unit_id: item.unit_id,
                  live_type: item.live_type,
                  module_type: 6,
                  url: res.data.catalog.info.live_url
                }
              })
            } else if (item.is_playback == 1) {
              this.$router.push({
                path: "/livevod",
                query: {
                  order_id: item.system_order,
                  package_id: item.package_id,
                  cid: item.coding,
                  unit_id: item.unit_id,
                  module_type: 66,
                  url: info.live_record_url
                }
              })
            } else {
              this.$router.push({
                path: "/livevod",
                query: {
                  order_id: item.system_order,
                  package_id: item.package_id,
                  cid: item.coding,
                  unit_id: item.unit_id,
                  live_type: item.live_type,
                  module_type: 6,
                  url: info.live_record_url
                }
              })
            }
          } else if (res.code == 2) {
            this.$router.push({ path: "/" });
          }
        })
      } else if (item.unit_type == 66) {
        if (item.live_type == 3) {
          this.$api.GETCATALOG({
            system_order_num: item.system_order,
            package_id: item.package_id,
            coding: item.coding,
            menu_id: item.unit_id
          }).then((res) => {
            if (res.code == 0) {
              let info = res.data.catalog.info
              this.$router.push({
                path: "/livevod",
                query: {
                  order_id: item.system_order,
                  package_id: item.package_id,
                  cid: item.coding,
                  unit_id: item.unit_id,
                  live_type: item.live_type,
                  module_type: 66,
                  url: info.live_record_url
                }
              })
            } else if (res.code == 2) {
              this.$router.push({ path: "/" });
            }
          })
        } else if (item.live_type == 1) {
          this.$api.GETCATALOG({
            system_order_num: item.system_order,
            package_id: item.package_id,
            coding: item.coding,
            menu_id: item.unit_id
          }).then((res) => {
            if (res.code == 0) {
              this.$router.push({
                path: "/livevod",
                query: {
                  order_id: item.system_order,
                  package_id: item.package_id,
                  cid: item.coding,
                  unit_id: item.unit_id,
                  live_type: 1,
                  module_type: 66,
                  url: res.data.catalog.info.playback_url
                }
              })
            } else if (res.code == 2) {
              this.$router.push({ path: "/" });
            }
          })
        } else {
          this.zujian_flag = true
          this.$nextTick(() => {
            var btn = document.getElementById('launch-btn')
            btn.addEventListener('launch', function(e) {
              this.handleJudgeWechat(); //是否满足跳转app条件
            });
          })
        }
      } else if (item.unit_type == 7) {
        this.$api.GETCATALOG({
          system_order_num: item.system_order,
          package_id: item.package_id,
          coding: item.coding,
          menu_id: item.unit_id
        }).then((res) => {
          if (res.code == 0) {
            this.$router.push({
              path: "/file",
              query: {
                order_id: item.system_order,
                package_id: item.package_id,
                cid: item.coding,
                unit_id: item.unit_id,
                module_type: 7,
                other: item.other,
                url: JSON.parse(item.other).url
              }
            })
          } else if (res.code == 2) {
            this.$router.push({ path: "/" });
          }
        })
      }
    },
    cancel_flag() {
      this.zujian_flag = false
    },
    search_flag() {
      if(!this.isweixin){
        this.arshow = false;
        if (this.sf == 'zgyouzhi'){
          if (this.android) {
            var SERVER_BASE_URL
            if (process.env.NODE_ENV=='production') {
              SERVER_BASE_URL = 'https://zgjyapp.offcn.com/web/app/youzhi_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
            } else {
              SERVER_BASE_URL = 'http://tiku.eoffcn.com/web/app/youzhi_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
            }
            this.openApp(SERVER_BASE_URL);
          } else if (this.ios) {
            location.href = 'https://www.eoffcn.com/zg_youzhi/detail?type=2&orderSn=' + this.$route.query.order_id + '&spuID=' + this.dataList.goodsId + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
          }
        } else {
          if (this.android) {
            var SERVER_BASE_URL
            if (process.env.NODE_ENV=='production') {
              SERVER_BASE_URL = 'https://zgjyapp.offcn.com/web/app/offcn_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
            } else {
              SERVER_BASE_URL = 'http://tiku.t.eoffcn.com/web/app/offcn_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
            }
            this.openApp(SERVER_BASE_URL);
          } else if (this.ios) {
            location.href = 'https://www.eoffcn.com/zg_jiaoyu/detail?type=2&orderSn=' + this.$route.query.order_id + '&spuID=' + this.dataList.goodsId + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
          }
        }
      }else{
        this.arshow = true;
      }
    },
    openApp (src) {
      var d = new Date()
      var t0 = d.getTime()
      var delay = setInterval(function() {
        var d = new Date();
        var t1 = d.getTime();
        if( t1-t0<3000 && t1-t0>2000) {
          window.location.href = src;
        }
        if (t1 - t0 >= 3000) {
          clearInterval(delay);
        }
      },2000);
    }
  },
  mounted() {
    // 小程序内
    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        this.isapplets = true
      }
    })
    this.getRecord(this.page)
    //是否是微信浏览器
    if (/(micromessenger)/i.test(navigator.userAgent)) {
      //是否电脑微信或者微信开发者工具
      if(/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)){
        console.log('电脑微信或者微信开发者工具')
        this.isweixin = false;
      }else{
        //手机微信打开的浏览器
        console.log('手机微信')
        this.isweixin = true;
      }
    } else {
      console.log('其他浏览器')
      this.isweixin = false;
    }
    this.sf = this.$route.query.sf
    if (this.sf == 'zgyouzhi') {
      this.appid = 'wx91652b0b55a2ca52'
      this.appname = '优职'
      this.scheme = 'zgyouzhi://openapp'
    } else {
      this.appid = 'wx4a8209bce2ce2a1d'
      this.appname = '中公教育'
      this.scheme = 'zhonggongjiaoyu://openapp'
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-timeline-item:first-child .el-timeline-item__node--normal {
  background: red;
}
#launch-btn {
  position: absolute;
  right: 0;
  width: 242px;
  height: 68px;
  opacity: 0;
}
.record-package {
  width: 100%;
  min-height: 100%;
  background: #ffffff;
  .header {
    position: fixed;
    top: 0;
    width: 100%;
    height: 90px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px 0 25px;
    color: #333;
    z-index: 1;
    border-bottom: 1px solid #e5e5e5;
    .title {
      font-size: 32px;
      font-weight: bold;
    }
    .exp {
      width: 62px;
    }
  }
  .record_content {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: auto;
    padding: 100px 30px 30px 50px;
    .record_detail {
      padding-left: 40px;
      border-left: 1px solid #e6e6e6;
      .record_date {
        position: relative;
        padding-top: 40px;
        font-size: 30px;
        font-weight: bold;
      }
      .record_date::before {
        display: block;
        content: '';
        position: absolute;
        left: -56px;
        bottom: 2px;
        width: 28px;
        height: 28px;
        border: 4px solid #cd4138;
        border-radius: 50%;
        background: #fff;
      }
      .record_descript {
        padding-bottom: 30px;
        border-bottom: 1px dashed #e5e5e5;
      }
      .record_descript:last-child{
        border: none;
      }
    }
    .record_detail:first-child .record_date{
      padding-top: 0;
      margin-top: 40px;
    }
  }
  .record_date {
    &:first-child{
      padding-top: 0;
    }
  }
  .record_time {
    font-size: 24px;
    margin-top: 40px;
  }
  .record_pathname {
    margin-top: 30px;
    color: #999999;
  }
  .record_info {
    display: flex;
    align-items: center;
    margin-top: 20px;
    img {
      width: 47px;
      height: 44px;
    }
  }
  .record_type {
    margin-left: 20px;
    .record_name {
      font-size: 28px;
      font-weight: bold;
    }
    .record_icon {
      margin-top: 16px;
      color: #999999;
    }
  }
  .no_more {
    text-align: center;
    color: #999999;
    margin-top: 50px;
    color: #999999;
  }
}
.nodata{
    text-align: center;
  color: #999;
  font-size: 26px;
  padding-top: 180px;
  img{
    width: 280px;
    height: 211px;
    margin-bottom: 23px;
  }
}
.class_dialog {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
  z-index: 1;
  .dialog_box {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 490px;
    line-height: 40px;
    border-radius: 18px;
    transform: translate(-50%, -50%);
    background: #fff;
    .dialog_message {
      text-align: center;
      padding: 30px 30px;
    }
    p {
      display: flex;
      border-top: 1px solid #e5e5e5;
      height: 70px;
      line-height: 70px;
      span {
        flex: 1;
        text-align: center;
      }
      .goapp {
        color: #e60012;
        border-left: 1px solid #e5e5e5;
        a {
          color: #e60012;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/record/record.vue